itsoftApp.createModule("popups", function() {
    var $body, $document, $window, $wrapper, clearScrollStyles, closePopupBtnClick, closePopupBtns, dAttrBgClose, dAttrSelector, evNameClose, evNameOpen, fixedPageElems, getScrollbarWidth, hasFixedElems, hiddenClass, keyController, module, openPopupBtnClick, openPopupBtns, openedClass, popupClass, popupClick, popupClose, popupOpen, popups, transitionEventEnd, windowUnload, wrapperAbsClass;
    popupClass = "popup";
    popups = $("." + popupClass);
    if (!popups.length) {
        return false;
    }
    module = this;
    openedClass = "is-opened";
    $body = itsoftApp.commonVars.$body;
    $document = itsoftApp.commonVars.$document;
    $window = itsoftApp.commonVars.$window;
    dAttrSelector = "data-popup-selector";
    dAttrBgClose = "data-bg-close";
    hiddenClass = "g-hidden";
    evNameOpen = "popups:open";
    evNameClose = "popups:close";
    openPopupBtns = $(".js-open-popup");
    closePopupBtns = $(".js-close-popup");
    $wrapper = itsoftApp.commonVars.$wrapper;
    wrapperAbsClass = "is-abs";
    transitionEventEnd = itsoftApp.features.transitionEventEnd;
    fixedPageElems = $(".js-page-fixed-elem");
    hasFixedElems = fixedPageElems.length > 0;
    popups.each(function() {
        var self;
        self = $(this);
        return $body.append(self.removeClass(hiddenClass));
    });
    popupOpen = function() {
        var scrTop, scrollbarWidth, self;
        self = $(this);
        if (self.hasClass(openedClass)) {
            return;
        }
        scrTop = Math.max($body.scrollTop(), $document.scrollTop(), $wrapper.scrollTop());
        $wrapper.addClass(wrapperAbsClass).scrollTop(scrTop);
        DEBUG && console.log("[module popups] scrTop: " + scrTop);
        if (hasFixedElems) {
            scrollbarWidth = getScrollbarWidth();
            DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
            fixedPageElems.css("padding-right", "" + scrollbarWidth + "px");
        }
        module.isOpened = true;
        self.addClass(openedClass);

        if (!$("#contacts").length){
            return
        }
        $("#contacts").scrollTop(0);
        return DEBUG && console.log("[module popups] opened popup: " + (self.attr("id") ? "#" + self.attr("id") : "." + self.attr("class")));
    };
    clearScrollStyles = function() {
        var scrTop;
        scrTop = Math.max($body.scrollTop(), $document.scrollTop(), $wrapper.scrollTop());
        DEBUG && console.log("[module popups] scrTop: " + scrTop);
        $wrapper.removeClass(wrapperAbsClass);
        fixedPageElems.css("padding-right", "");
        return $document.scrollTop(scrTop);
    };
    popupClose = function() {
        var end, self;
        self = $(this);
        if (!self.hasClass(openedClass)) {
            return;
        }
        self.removeClass(openedClass);
        end = function() {
            return setTimeout(function() {
                clearScrollStyles();
                return module.isOpened = false;
            }, 200);
        };
        if (transitionEventEnd) {
            self.one(transitionEventEnd, end);
        } else {
            end();
        }
        return DEBUG && console.log("[module popups] closed popup: " + (self.attr("id") ? "#" + self.attr("id") : "." + self.attr("class")));
    };
    popupClick = function(e) {
        var self;
        self = $(this);
        if (e.target === this && self.attr(dAttrBgClose) !== "false") {
            return self.trigger(evNameClose);
        }
    };
    openPopupBtnClick = function() {
        var popup, selector, self;
        self = $(this);
        selector = self.attr(dAttrSelector);
        popup = popups.filter(selector);
        return popup.trigger(evNameOpen);
    };
    closePopupBtnClick = function() {
        var popup, self;
        self = $(this);
        popup = self.closest("." + popupClass);
        return popup.trigger(evNameClose);
    };
    getScrollbarWidth = function() {
        var inner, outer, widthNoScroll, widthWithScroll;
        if ($wrapper.height() <= $window.height()) {
            return 0;
        }
        outer = document.createElement("div");
        inner = document.createElement("div");
        widthNoScroll = void 0;
        widthWithScroll = void 0;
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        document.body.appendChild(outer);
        widthNoScroll = outer.offsetWidth;
        outer.style.overflow = "scroll";
        inner.style.width = "100%";
        outer.appendChild(inner);
        widthWithScroll = inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    windowUnload = function() {
        popups.trigger(evNameClose);
        clearScrollStyles();
    };
    keyController = function(e) {
        var openedPopups;
        openedPopups = popups.filter("." + openedClass);
        if (!openedPopups.length) {
            return;
        }
        if (e.keyCode === 27) {
            return openedPopups.last().trigger(evNameClose);
        }
    };
    popups.on(evNameOpen, popupOpen);
    popups.on(evNameClose, popupClose);
    openPopupBtns.on("click", openPopupBtnClick);
    closePopupBtns.on("click", closePopupBtnClick);
    popups.on("click", popupClick);
    $window.on("beforeunload", windowUnload);
    $window.on("keyup", keyController);
    if (DEBUG && typeof describe === "function") {
        return describe("[module popups]", function() {
            it("all popups must be moved on <body> level", function() {
                return popups.each(function() {
                    return expect(this.parentElement.nodeName.toLowerCase()).to.be.equal("body");
                });
            });
            return it("each popup must have custom events: " + evNameOpen + " and " + evNameClose, function() {
                return popups.each(function() {
                    var obj;
                    obj = $._data(this, "events");
                    expect(evNameOpen in obj).to.be.equal(true);
                    return expect(evNameClose in obj).to.be.equal(true);
                });
            });
        });
    }
});

/*
//@ sourceMappingURL=popups.map
*/